import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { recieve_Request,Request_Approve } from "../../apis/api/FreightRerquestApi";
import SentRequestView from "../../Models/Freight_RequestModel/Sent_requestViewModel";
import Lodderr from "../Lodder/Lodder";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Receive_Request = () => {
  const dispatch = useDispatch();
  const [update, setUpdate] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();

  const { RecieveRequest, loading } = useSelector(
    (state) => state.FreightRequest
  );

  const userId = Cookies.get("userID");

  useEffect(() => {
    
    if (userId) {
      dispatch(recieve_Request({ id: userId }));
    }
    setUpdate(false);
  }, [dispatch, update]);

  const handleApprove = async() => {
  
    const response= await dispatch(Request_Approve({ reqId: selectedItem.id,userId ,cust_id:selectedItem.cus_id }));
  
    if(response.payload.status=="success"){
      setShowConfirmModel(false);
      setUpdate(true); 
      navigate('/accept_request')
      toast.success(response.payload.message);
    }else if(response.payload.status=="error"){
      toast.success(response.payload.message);
    }

    
  };

  return (
    <>
      {loading && <Lodderr />}

      {/* View Modal */}
      <SentRequestView
        show={showModel}
        handleClose={() => setShowModel(false)}
        data={selectedItem}
      />

      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={showConfirmModel}
        onConfirm={handleApprove}
        onCancel={() => setShowConfirmModel(false)}
        message="Are you sure you want to Accept this request?"
      />

      <CustomTableWrapper
        data={RecieveRequest}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={[
          "random_id",
          "full_name",
          "company_name",
          "created_at",
        ]}
        columns={[
          { label: "Request ID", field: "random_id", sortable: true },
          { label: "Sender Member Names", field: "full_name", sortable: true },
          { label: "Sender Company Names", field: "company_name", sortable: true },
          { label: "Entry Date", field: "created_at", sortable: true },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index) => (
          <tr key={index}>
            <td>{item.random_id}</td>
            <td>{item.full_name}</td>
            <td>{item.company_name}</td>
            <td>
              {
                (() => {
                  const date = new Date(item.created_at * 1000);
                  return date.toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  }); 
                })()
              }
            </td>
            <td>
              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-sm btn-warning text-light"
                  onClick={() => {
                    setSelectedItem(item);
                    setShowModel(true);
                  }}
                >
                  <i className="bx bx-show"></i>
                </button>
                <button
                  className="btn btn-sm btn-success text-light"
                  onClick={() => {
                    setSelectedItem(item);
                    setShowConfirmModel(true);
                  }}
                >
                  <i className="bx bx-check"></i>
                </button>
              </div>
            </td>
          </tr>
        )}
      />
    </>
  );
};

export default Receive_Request;
